import { Component, Signal, ViewEncapsulation, computed, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute } from '@angular/router';
import { NewsArticlesStore, NewsArticlesStoreType } from '@appState';
import { ParseHtmlPipe, formatDate } from 'cui-components';
import { environment } from 'src/environments/environment';

@Component({
  imports: [ReactiveFormsModule, MatProgressSpinnerModule, ParseHtmlPipe],
  selector: 'hui-news-article-preview',
  templateUrl: './news-article-preview.component.html',
  styleUrls: ['./news-article-preview.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NewsArticlePreviewComponent {
  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private newsArticlesStore: NewsArticlesStoreType = inject(NewsArticlesStore);

  isLoading: Signal<boolean> = this.newsArticlesStore.isSelectedNewsArticleLoading;

  newsArticle = this.newsArticlesStore.selectedNewsArticle;

  keywords: Signal<string[]> = computed(() =>
    (this.newsArticle()?.keywords ?? []).map(keyword => keyword.trim()).filter(keyword => !!keyword),
  );

  getDateString(date: Date): string {
    return formatDate(date, 'dd MMMM, yyyy');
  }

  environment = environment;

  constructor() {
    const id = this.activatedRoute.snapshot.paramMap.get('articleId')!;

    this.newsArticlesStore.getNewsArticle({ id, includeContent: true });
  }
}
